module.exports = __webpack_public_path__ + "static/media/black-clarks.d141cfe8.jpg";